import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';
import { environment } from 'environments/environment';
import { CMSDynamicService } from 'app/services/yoklama/cms-service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
})
export class FeedbackComponent implements OnInit {
  feedbackForm!: FormGroup;
  imageUrl: string | null = null;

  updates: any[] = [];

  feedbackTypes = [
    'Yoklama Oluşturma (Öğretim Görevlisi)',
    'Yoklamaya Katılma',
    'Cihaz Ekleme / Değiştirme',
    'Öneri / Şikayet',
  ];

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private httpservice: CMSDynamicService,
    private alertService: CustomToastrService,
  ) {}
  closeModal() {
    this.showInfoModal = false;
    localStorage.setItem('akilliYoklamaModalShown', 'true');
  }
  ngOnInit(): void {
    this.loadUpdates();
    this.buildForm();
    this.loadStudentFeedbacks();
    const modalShown = localStorage.getItem('akilliYoklamaModalShown');
    if (!modalShown) {
      this.showInfoModal = true;
    }
  }
  openedIndex: number | null = 0; // ilk kayıt AÇIK gelsin istiyorsan 0, istemiyorsan null
  async loadStudentFeedbacks() {
    this.studentFeedbacks = await this.getStudentFeedbacks();
  }
  toggle(i: number): void {
    this.openedIndex = this.openedIndex === i ? null : i;
  }
  private buildForm(): void {
    this.feedbackForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      program: ['', Validators.required],
      feedback: ['', [Validators.required, Validators.minLength(10)]],
      image: [''],
    });
  }

  // 📦 Local assets JSON
  async loadUpdates(): Promise<void> {
    this.http.get<any[]>('assets/app-updates.json').subscribe({
      next: (res) =>
        (this.updates = res.sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        )),
    });


  }
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) return;

    this.uploadFile(input.files);
  }

  getStatusClass(status: boolean): string {
    return status ? 'feedback-approved' : 'feedback-pending';
  }

  getBadgeClass(status: boolean): string {
    return status ? 'badge-success' : 'badge-warning';
  }

  showInfoModal: boolean = false;
  async getStudentFeedbacks(): Promise<any[]> {
    try {
      var ogrenci = localStorage.getItem('ogrenciMi') === 'true';
      // Öğrenci numarasını al
      //  const studentId = ogrenci ? this.getFirstUserNoFromLocalStorage():this.getFirstUserTcFromLocalStorage();

      const studentId = this.getFirstUserNoFromLocalStorage();
      if (!studentId) return [];

      // Backend URL param ile
      const payload = null; // GET için body yok

      // Eğer postCustom sadece POST için yazıldıysa, bunu GET destekli versiyon olarak da ekleyebiliriz:
      const res: any = await this.httpservice.getBildirim(
        'CMS',
        'GetListFeedBackStudent?Page=0&PageSize=5000&Filter.Field=Kanal&Filter.Operator=eq&Filter.Value=yoklama&studentid=' +
          studentId,
      );

      // Örnek: res.data array olarak dönüyorsa
      return res.items || [];
    } catch (error) {
      console.error('Feedback listesi alınamadı:', error);
      return [];
    }
  }

  // 📷 Image upload
  uploadFile(files: FileList) {
    if (!files || files.length === 0) return;

    const formData = new FormData();
    formData.append('file', files[0]); // field adı 'file'

    // postCustom methodu JSON Content-Type atıyorsa kaldır, default form-data kalsın
    this.httpservice
      .postFileUpload('CMS', 'FileUploadYoklama', files)
      .then((res: any) => {

        this.imageUrl = res.imageUrl;
        this.feedbackForm.get('image')?.setValue(this.imageUrl);
      })
      .catch((err) => {
        this.alertService.message('Dosya yüklenemedi', 'Hata', {
          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopFullWidth,
        });
      });
  }

  getFirstUserNoFromLocalStorage(): number {
    const userListStr = localStorage.getItem('userList');
    if (!userListStr) return 0;

    try {
      const userList = JSON.parse(userListStr);
      if (userList.data && userList.data.length > 0) {
        const userNoStr = userList.data[0].userNo;
        return userNoStr ? parseInt(userNoStr, 10) : 0;
      }
      return 0;
    } catch (err) {
      console.error('localStorage parse hatası:', err);
      return 0;
    }
  }

  getFirstUserTcFromLocalStorage(): number {
    const userListStr = localStorage.getItem('userList');
    if (!userListStr) return 0;

    try {
      const userList = JSON.parse(userListStr);
      if (userList.data && userList.data.length > 0) {
        const userNoStr = userList.data[0].tcNo;
        return userNoStr ? parseInt(userNoStr, 10) : 0;
      }
      return 0;
    } catch (err) {
      console.error('localStorage parse hatası:', err);
      return 0;
    }
  }
  studentFeedbacks: any[] = [];
  // 🚀 Submit
  submitFeedback() {
    if (this.feedbackForm.invalid) {
      console.log('A');
    }

    const payload = {
      feedBack: {
        message: this.feedbackForm.value.program,
        studentId: this.getFirstUserNoFromLocalStorage(), // token’dan sonra alınacak
        email: this.feedbackForm.value.email,
        program: this.feedbackForm.value.program,
        feedBack: this.feedbackForm.value.feedback,
        image: this.feedbackForm.value.image,
        status: false,
        isVisible: false,
        kanal: 'yoklama',
      },
    };

    this.httpservice
      .postCustom(
        'CMS', // controller
        'AddFeedBack', // action
        '', // message (toast'ı biz basacağız)
        payload,
      )
      .then(() => {
        /* this.alertService.message('Geri bildirimin alındı 👍', 'Teşekkürler', {
          messageType: ToastrMessageType.Success,
          position: ToastrPosition.TopFullWidth,
        }); */

        this.feedbackForm.reset();
        this.imageUrl = null;
      })
      .catch(() => {
        /*  this.alertService.message('Geri bildirim gönderilemedi', 'Hata', {
          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopFullWidth,
        }); */
      });
  }
}
